import React from "react";
import IconIntegratedForms from "@components/icons/iconIntegratedForms";
import IconTwoWayTexting from "@components/icons/iconTwoWayTexting";
import IconPayrollProcessing from "@components/icons/iconPayrollProcessing";

const PRICING_PLANS = [
  {
    id: 0,
    name: "Essentials",
    price: "165",
    mainLimit: "For small teams",
    aspects: ["2 to 10 service providers", "Unlimited SMS & email notifications", "Add-on integrations available"],
  },
  {
    id: 1,
    name: "Standard",
    price: "245",
    mainLimit: "For busy salons & spas",
    aspects: [
      "Up to 20 service providers",
      "Advanced features: Express Booking™, Virtual Waiting Room, Memberships",
      "Standard integrations included",
    ],
    mostPopular: true,
  },
  {
    id: 2,
    name: "Unlimited",
    price: "375",
    mainLimit: "For large businesses",
    aspects: [
      "Unlimited service providers",
      "All essentials, plus advanced features",
      "Shopify and other integrations included. Custom APIs available",
    ],
  },
];

const PRICING_ADD_ONS = [
  {
    id: 0,
    icon: <IconIntegratedForms />,
    title: "Forms & Charting",
    description: "Collect and organize important client data, treatment notes, and more.",
    link: "/features/integrated-forms/",
    price: "$50/month (+$25 per additional location)",
  },
  {
    id: 1,
    icon: <IconTwoWayTexting />,
    title: "Two-Way Texting",
    description: "Communicate with clients and manage conversations all in one place.",
    link: "/features/two-way-texting/",
    price: "$75/month (+$25 per additional location)",
  },
  {
    id: 2,
    icon: <IconPayrollProcessing />,
    title: "Payroll Processing",
    description: "Ditch extra systems and make payday easy with built-in payroll processing.",
    link: "/features/payroll-processing/",
    price: "$50/month (+$8 per worker)",
  },
];

export { PRICING_ADD_ONS, PRICING_PLANS };
